<script lang="ts">
    import { _ } from "svelte-i18n"
    import { contentFloaterPath } from "../../store"
    import Content from "../routes/Content.svelte"
</script>

<style lang="less">
    .content-floater {
        padding: 0px;
        width: 30vw;
        background-color: #fff;
        border-left: solid 1px #ccc;
        position: fixed;
        top: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 999999;
        @media (max-width: 1700px) {
            width: 50vw;
        }
        @media (max-width: 768px) {
            width: 100vw;
        }
        .floater_content {
            position: absolute;
            top: 65px;
            bottom: 0;
            overflow-y: scroll;
        }
        .closer {
            cursor: pointer;
            background: #f4f4f4;
            display: flex;
            display: -webkit-flex;
            align-items: center;
            color: #464646;
            border-bottom: solid 1px #ccc;
            padding: 3px 20px;
            margin-bottom: 20px;
            font-size: 18px;
            height: 65px;
            svg {
                margin-right: 10px;
                background: var(--renzrot);
                color: #fff;
            }
        }
        :global h2 {
            font-size: 2rem;
            @media (max-width: 1024px) {
                font-size: 1.6rem;
            }
        }
    }
</style>

{#if $contentFloaterPath}
    <div class="content-floater">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="closer"
            role="button"
            tabindex="0"
            on:click="{() => {
                $contentFloaterPath = null
            }}"
        >
            <svg width="1em" height="1em" viewBox="0 0 24 24"
                ><path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" fill="currentColor"
                ></path></svg
            > <span class="text">{$_("general.close")}</span>
        </div>
        <div class="floater_content">
            <Content path="{$contentFloaterPath}" />
        </div>
    </div>
{/if}
